import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';
import { AppErrors, ConflictError, NotFoundError } from '@fitness-force/models';;

import { environment } from '@fitness-force/environments';
import { throwError, Observable, pipe } from 'rxjs';
import { catchError, map, retry } from 'rxjs/operators';
import { OpportunityBoardType } from '@fitness-force/enum';
import type { CreateResponse } from '@fitness-force/models';

@Injectable({
  providedIn: 'root',
})
export class TaxMasterService {
  private http = inject(HttpClient);
  private router = inject(Router);


  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  getTaxGroups(tenantId: number,allParams:Array<string>=[]) {
    let parsedParams = new HttpParams()
    if(allParams.length > 0){

     allParams.forEach((p: any) => {

       parsedParams = parsedParams.append(p.name, p.value);
     });
    }
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.TAX.GET_TAX_GROUPS
      .replace('{tenant_id}', tenantId.toString());
    return this.http
      .get(
        url,
        {headers: this.httpOptions.headers , params: parsedParams}
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }
  getTaxSetting(tenantId:number,tentstgKey:string){
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.TAX.GET_TAX_SETTING
      .replace('{tenant_id}', tenantId.toString())
      .replace('{setting_key}', tentstgKey);
    return this.http
      .get(
        url,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getAllTaxSetting(tenantId:number){
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.TAX.GET_ALL_TAX_SETTINGS
      .replace('{tenant_id}', tenantId.toString());
    return this.http
      .get(
        url,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  updateTaxSettings(tenantId: number,  data: any) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.TAX.UPDATE_TAX_SETTINGS
      .replace('{tenant_id}', tenantId.toString());
    return this.http
      .put(
        url,
        data,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getTaxLineItems(tenantId: number, groupId: number) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.TAX.GET_TAX_LINE_ITEMS
      .replace('{tenant_id}', tenantId.toString())
      .replace('{group_id}', groupId.toString());
    return this.http
      .get(
        url,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }
  getTaxLineItem(tenantId: number, groupId: number,taxLineItemId:number) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.TAX.GET_TAX_LINE_ITEM_BY_ID
      .replace('{tenant_id}', tenantId.toString())
      .replace('{group_id}', groupId.toString())
      .replace('{line_item_id}', taxLineItemId.toString());
    return this.http
      .get(
        url,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getTaxLineItemTypes(tenantId: number) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.TAX.GET_TAX_LINE_ITEM_TYPES
      .replace('{tenant_id}', tenantId.toString());
    return this.http
      .get(
        url,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }


  createTaxGroup(tenantId: number,  data: any) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.TAX.CREATE_TAX_GROUP
      .replace('{tenant_id}', tenantId.toString());
    return this.http
      .post(
        url,
        data,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  createTaxLineItem(tenantId: number, groupId: number, data: any) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.TAX.CREATE_TAX_LINE_ITEM
      .replace('{tenant_id}', tenantId.toString())
      .replace('{group_id}', groupId.toString());
    return this.http
      .post(
        url,
        data,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  updateTaxGroup(tenantId: number, groupId: number, data: any) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.TAX.UPDATE_TAX_GROUP
      .replace('{tenant_id}', tenantId.toString())
      .replace('{group_id}', groupId.toString());
    return this.http
      .put(
        url,
        data,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  updateTaxLineItem(tenantId: number, groupId: number,lineItemId:number, data: any) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.TAX.UPDATE_TAX_LINE_ITEM
      .replace('{tenant_id}', tenantId.toString())
      .replace('{group_id}', groupId.toString())
      .replace('{line_item_id}', lineItemId.toString());
    return this.http
      .put(
        url,
        data,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  deleteTaxGroup(tenantId: number, groupId: number) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.TAX.DELETE_TAX_GROUP
      .replace('{tenant_id}', tenantId.toString())
      .replace('{group_id}', groupId.toString());
    return this.http
      .delete(
        url
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          if (error.status === 409) {
            return throwError(() => new ConflictError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }


}
